import { event } from "./event";

/**
 * tutorial_begin
 * このイベントは、オンボーディング プロセスの開始を示します。
 * チュートリアルを完了したユーザー数を把握するには、このイベントを目標到達プロセスで tutorial_complete とともに使用します。
 * このイベントのパラメータはありません。
 */
export const  tutorial_begin = () => event('tutorial_begin');